import NotificationActions from '../../actions/NotificationActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';

import { endPoints as EndPoints } from '../../constants/GuestConstants';

import Input from '../form/input/Input.react';
import InputDOB from '../form/input/InputDOB.react';
import InputPhone from '../form/input/InputPhone.react';
import InputProfile from '../profile/view/InputProfile.react';
import DropdownProfile from '../profile/view/DropdownProfile.react';

import PageHeader from '../form/layout/PageHeader.react';
import PageRow from '../form/layout/PageRow.react';
import PermissionStore from '../../stores/PermissionStore';
import { Permissions } from '../../constants/PermissionConstants';
import DD from '../form/dropdown/DD.react';
import AjaxPromises from '../../utils/AjaxPromises';

class NewProfile extends React.Component {

    constructor(props) {
        super(props);

        // TODO :: camel case
        this.state = {
            loading         : false,
            namePrefix      : '',
            firstName       : '',
            middleName      : '',
            lastName        : '',
            nameSuffix      : '',
            patient_type    : 'Medical',
            status          : 'Active',
            expiration_date : '',
            start_date      : '',
            state_id_no     : '',
            phone_no        : '',
            email           : '',
            mobile_no       : '',
            preferredMethodOfContact: '',
            customerTypes: [],
            customerTypeId: '',
        };

        this.createNewProfile = this.createNewProfile.bind(this);
        this.validate = this.validate.bind(this);
        this.setCustomerTypes = this.setCustomerTypes.bind(this);
    }

    componentDidMount() {
        this.setCustomerTypes();
        UserStore.addChangeListener(this.setCustomerTypes);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.setCustomerTypes);
    }

    setCustomerTypes() {
        var customerTypes = [{ title: '-', option: ''}];
        var userData = UserStore.getState();
        var selectedLocation = userData.selectedLocation;

        userData.customerTypes.forEach(t => {
            customerTypes.push({ title: t.CustomerType, option: t.CustomerTypeId });
        });

        if (selectedLocation && selectedLocation.DefaultCustomerTypeId) {
            this.setState({ customerTypeId: selectedLocation.DefaultCustomerTypeId });
        } else {
            if (customerTypes.length === 2) {
                this.setState({ customerTypeId : customerTypes[1].option });
            }
        }

        this.setState({ customerTypes });        
    }    

    setPatientData(x) {
    }

    createNewProfile() {
        var self = this;

        if (!this.validate()) {
            return;
        }

        if (this.state.loading) {
            return;
        }

        var formData            = UserStore.getApiData();

        formData.NamePrefix     = this.state.namePrefix;
        formData.FirstName      = this.state.firstName;
        formData.MiddleName     = this.state.middleName;
        formData.LastName       = this.state.lastName;
        formData.NameSuffix     = this.state.nameSuffix;

        formData.status         = this.state.status;
        formData.street         = this.state.address;
        formData.city           = this.state.city;
        formData.state          = this.state.county;
        formData.MJStateIDNo    = this.state.state_id_no.replace(/ /g,'');
        formData.ExpirationDate = this.state.expiration_date;
        formData.MJStateIDStartDate = this.state.start_date;
        formData.CustomerTypeId = this.state.customerTypeId;
        formData.PhoneNo        = this.state.phone_no;
        formData.CellPhone      = this.state.mobile_no;
        formData.Email          = this.state.email;
        formData.PreferredMethodOfContact = this.state.preferredMethodOfContact;

        // formData.status         = 'N/A';
        formData.street         = 'N/A';
        formData.city           = 'N/A';
        formData.state          = 'N/A';

        formData.country_code   = 'US';

        this.setState({ loading : true }, () => {

            AjaxPromises.POST(EndPoints.CREATE_NEW_GUEST,
                formData).then(res => {
                    if (res.Result) {
                        if (res.Data[0].PatientUpdated === 0) {
                            self.setState({ loading : false }, () => {
                                NotificationActions.error(res.Data[0].PatientResponse || 'Error');
                            });
                        } else {
                            NotificationActions.addNotification({type : res.Result ? 'success' : 'error', body : res.Message});
                            self.setState({
                                loading         : false,
                                namePrefix      : '',
                                firstName       : '',
                                middleName      : '',
                                lastName        : '',
                                nameSuffix      : '',
                                patient_type    : 'Medical',
                                status          : 'Active',
                                expiration_date : '',
                                start_date      : '',
                                state_id_no     : '',
                                phone_no        : '',
                                mobile_no       : '',
                                email           : '',
                                preferredMethodOfContact : '',
                            }, () => {
                                PopupActions.viewProfile(res.Data[0]);
                                // RoutingActions.updateRoute('pos/'+res.Data[0].Guest_id);
                            });
                        }
                    } else {
                        self.setState({ loading : false }, () => {
                            NotificationActions.error(res.Message || 'Error');
                        });
                    }
                }
            );
        });
    }

    validateEmail(email) {
        if (!email) {
            return true;
        }

        const pattern = '^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        var regex = new RegExp(pattern);
        return regex.test(email);
    }

    validate(silent) {
        var error = false;

        if (this.state.firstName.length < 1) {
            error = 'First Name is required';
        }

        if (this.state.lastName.length < 1) {
            error = 'Last Name is required';
        }

        if (!error && this.state.status.length < 2) {
            error = 'Patient Status is required';
        }

        if (!error && !this.state.customerTypeId) {
            error = 'Patient Type is required';
        }

        var customerTypeId = parseInt(this.state.customerTypeId);
        if ([1,10].indexOf(customerTypeId) >= 0) {
            if (!error && this.state.state_id_no.length < 1) {
                error = 'ID number is required';
            }

            if (!error && (this.state.expiration_date.substr(0, 4) === '0000' || !(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(this.state.expiration_date)))) {
                error = 'Invalid ID expiration date';
            }
        }

        if (!silent && error !== false) {
            NotificationActions.addNotification({
                type : 'alert',
                body : error,
            });
        }

        return !error ? true : false;
    }

    render() {
        var userData = UserStore.getState();
        var selectedLocation = userData.selectedLocation;
        var page = this.props.page;
        var valid = this.validate(true);

        if (page !== 'new-profile') {
            return null;
        }

        var customerTypeId = parseInt(this.state.customerTypeId);

        return (
            <div
                className='new-profile'>

                <div className='container'>

                    <PageHeader title='Create New Profile' />

                    <PageRow title='Prefix'>
                        <Input tabindex="1"
                            value={this.state.namePrefix}
                            onChange={namePrefix => { this.setState({ namePrefix }); }} />
                    </PageRow>

                    <PageRow title='First Name'>
                        <Input tabindex="2"
                            required
                            value={this.state.firstName}
                            onChange={firstName => { this.setState({ firstName }); }} />
                    </PageRow>

                    <PageRow title='Middle Name'>
                        <Input tabindex="3"
                            value={this.state.middleName}
                            onChange={middleName => { this.setState({ middleName }); }} />
                    </PageRow>

                    <PageRow title='Last Name'>
                        <Input tabindex="4"
                            required
                            value={this.state.lastName}
                            onChange={lastName => { this.setState({ lastName }); }} />
                    </PageRow>

                    <PageRow title='Suffix'>
                        <Input tabindex="5"
                            value={this.state.nameSuffix}
                            onChange={nameSuffix => { this.setState({ nameSuffix }); }} />
                    </PageRow>

                    <PageRow title='Patient Type'>
                        <DD tabindex="6"
                            options={this.state.customerTypes}
                            value={this.state.customerTypeId}
                            onChange={customerTypeId => this.setState({ customerTypeId })} 
                        />
                    </PageRow>

                    <PageRow title='Status'>
                        <DD tabindex="7"
                            required
                            disabled={!PermissionStore.userCan(Permissions.EditPOSCustomerStatus)}
                            value={this.state.status}
                            onChange={status => { this.setState({ status }); }}
                            options={
                            [
                                    { title: '-', option: ''},
                                    { title: 'Active', option: 'Active' },
                                    { title: 'Banned', option: 'Banned' },
                                    { title: 'Cancelled', option: 'Cancelled' },
                                    { title: 'Hold', option: 'Hold' },
                                    { title: 'Inactive', option: 'Inactive' },
                                ]
                            } />
                    </PageRow>

                    {
                        [1,10,20].indexOf(customerTypeId) >= 0 && [
                        <PageRow title='MMJ ID'>
                            <Input tabindex="8"
                                value={this.state.state_id_no}
                                onChange={state_id_no => { this.setState({ state_id_no }); }} />
                        </PageRow>,
                        userData.selectedLocation.MJIDStartDateField &&
                        <PageRow title='MMJ ID Start Date'>
                            <InputDOB tabindex="9"
                                value={this.state.start_date}
                                onChange={start_date => { this.setState({ start_date }); }} />
                        </PageRow>,   
                         <PageRow title='MMJ ID Expiration Date'>
                            <InputDOB tabindex="10"
                                value={this.state.expiration_date}
                                onChange={expiration_date => { this.setState({ expiration_date }); }} />
                        </PageRow>
                        ]
                    }

                    <PageHeader title='Additional Info (optional)' />

                    <PageRow title='Phone Number'>
                        <InputPhone tabindex="11"
                            value={this.state.phone_no}
                            onChange={phone_no => { this.setState({ phone_no }); }} />
                    </PageRow>

                    {selectedLocation.ShowContactDetailsNewProfile && [
                        <PageRow title='Mobile Phone Number'>
                            <InputPhone tabindex="12"
                                value={this.state.mobile_no}
                                onChange={mobile_no => { this.setState({ mobile_no }); }} />
                        </PageRow>,
                        
                        <PageRow title='Email Address'>
                            <InputProfile tabindex='13'
                                value={this.state.email}
                                onChange={(field, email, address) => { this.setState({ email });}}
                                validate={this.validateEmail} />
                        </PageRow>,

                        <PageRow title='Preferred Method of Contact'>
                            <DropdownProfile tabindex='14'
                                options={[
                                    { title: 'None', option: '' },
                                    { title: 'Phone', option: 'PhoneNo' },
                                    { title: 'Mobile Phone', option: 'CellPhone' },
                                    { title: 'E-Mail', option: 'Email' },
                                ]}
                                selected={this.state.preferredMethodOfContact}
                                onChange={(field, preferredMethodOfContact, address) => { this.setState({ preferredMethodOfContact });}} />
                        </PageRow>,
                    ]}

                    <div className='row'>
                        <div className='col-12'>
                            <div tabindex="15"
                                className={'new-profile__save btn-green '+(valid ? '' : 'btn-green__disabled')}
                                onClick={this.createNewProfile}>

                                Save
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewProfile;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/NewProfile.react.jsx